import Template from "./template";
import { service } from "../../../../../lib/itn-ui-kit/services/service-container";
import BaseRoute from "../../../../../lib/itn-ui-kit/route/base-route";

export default class FinanceCasesDetailRoute extends BaseRoute {
  @service('repositories/case-repository') caseRepository;

  path = ':id';
  element = <Template/>;

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { _case: null };
    } else {
      try {
        const _case = await this.caseRepository.findRecord(id);
        return { _case };
      } catch (error) {
        console.error(`Error getting case: ${id}`, error);
        return { _case: null };
      }
    }
  }
}
